'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseInlineTextArea = require('@bibliocommons/base-inline-text-area');

var _baseInlineTextArea2 = _interopRequireDefault(_baseInlineTextArea);

var _constantsList = require('@bibliocommons/constants-list');

var _restrictedLengthText = require('../../restricted-length-text');

var _restrictedLengthText2 = _interopRequireDefault(_restrictedLengthText);

require('../styles/DescriptionInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DescriptionInput = exports.DescriptionInput = function (_BcReactComponent) {
  _inherits(DescriptionInput, _BcReactComponent);

  function DescriptionInput(props) {
    _classCallCheck(this, DescriptionInput);

    var _this = _possibleConstructorReturn(this, (DescriptionInput.__proto__ || Object.getPrototypeOf(DescriptionInput)).call(this, props));

    _this.bindAll('handleChange');
    return _this;
  }

  _createClass(DescriptionInput, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.props.handleListPropertyChange(_immutable2.default.Map({ description: value }));
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.allowFreeText) {
        return null;
      }

      var prompt = this.props.prompt ? this.props.prompt : this.props.intl.formatMessage({ id: 'user_list_add_description' });
      return _react2.default.createElement(
        'div',
        { className: 'cp-description-input' },
        _react2.default.createElement(
          'label',
          { className: 'sr-only', id: 'list-description-label', htmlFor: 'list-description' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_list_edit_desc' })
        ),
        _react2.default.createElement(
          _baseInlineTextArea2.default,
          {
            id: 'list-description',
            value: this.props.value,
            suggestedMaxLength: _constantsList.LIST_DESCRIPTION_LENGTH_SOFT_LIMIT,
            maxLength: 4000,
            labelledById: 'list-description-label',
            handleChange: this.handleChange,
            prompt: prompt,
            customClass: 'list-description-input',
            fitToText: true,
            highlightOnHover: true,
            buttonTestId: 'edit-list-description-button',
            inputTestId: 'list-description-text-field' },
          _react2.default.createElement(
            'span',
            { 'data-test-id': 'list-description' },
            _react2.default.createElement(_restrictedLengthText2.default, {
              text: this.props.value,
              limit: _constantsList.LIST_DESCRIPTION_LENGTH_SOFT_LIMIT })
          )
        )
      );
    }
  }]);

  return DescriptionInput;
}(_baseBcReactComponent2.default);

DescriptionInput.propTypes = {
  value: _react.PropTypes.string,
  allowFreeText: _react.PropTypes.bool.isRequired,
  handleListPropertyChange: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  prompt: _react.PropTypes.string
};

exports.default = (0, _reactIntl.injectIntl)(DescriptionInput);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/description-input/components/DescriptionInput.component.js
// module id = 1290
// module chunks = 0